import React from 'react';
import { styled } from "styled-components";

const Wrapper = styled.div`
  .wrongData {
    color: #F7326D;
    font-variant-numeric: lining-nums proportional-nums;
    font-family: Raleway;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
`;

const ErrorMessage = ({ text }) => {
  return <Wrapper className='row'><p className='wrongData'>{text}</p></Wrapper>
};

export default ErrorMessage;
